import { render, staticRenderFns } from "./Variation.vue?vue&type=template&id=424a6932&scoped=true"
import script from "./Variation.vue?vue&type=script&lang=js"
export * from "./Variation.vue?vue&type=script&lang=js"
import style0 from "./Variation.vue?vue&type=style&index=0&id=424a6932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a6932",
  null
  
)

export default component.exports